import { CardApiClient } from './cardApiClient';
export function getFilters() {
    return CardApiClient.get('/v2/filters').then(function (response) { return response.data.data; });
}
